import React, { useEffect, useState, useMemo } from 'react';
import cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';
import moment from 'moment/moment';
import styles from './styles.module.scss';
import closeIcon from '../../assets/icons/close.svg';
import isYandexOrAtomBrowser from './isYandexOrAtomBrowser';

const IS_SHOW_BANNER_KEY = 'isShowBanner';

const isDateBetween = (startTime, endTime) => {
    const now = moment();

    const date1 = moment(startTime, 'DD.MM.YYYY HH:mm');
    const date2 = moment(endTime, 'DD.MM.YYYY HH:mm');

    // '[]' - включительно, '()' - исключительно
    return now.isBetween(date1, date2, null, '[]');
};

const transformLink = (url) => {
    const indexOfUpload = url.indexOf('upload');
    return url.substring(indexOfUpload);
};

const NotificationBar = ({ settings: { isActive, isClosable, backgroundColor, htmlText, icon, startTime, endTime, isShowAllPages, showPages, isShowInYandexOrAtom } }) => {
    const location = useLocation();
    const [isShow, setIsShow] = useState(false);

    const isDisplayBar = useMemo(() => {
        if (isActive) {
            let isDisplayOnPage;
            const isDisplayInPeriod = isDateBetween(startTime, endTime);

            if (isShowAllPages) {
                isDisplayOnPage = true;
            } else {
                isDisplayOnPage = showPages.includes(location.pathname);
            }
            return isDisplayOnPage && isDisplayInPeriod;
        }
        return false;
    }, [endTime, isActive, isShowAllPages, location.pathname, showPages, startTime]);

    const checkIfUserNeedBanner = () => {
        try {
            const isShowBanner = cookies.get(IS_SHOW_BANNER_KEY);
            if (!isShowBanner) return true;
            return JSON.parse(isShowBanner) !== false;
        } catch {
            return true;
        }
    };

    const saveBannerCookieState = (show) => {
        cookies.set(IS_SHOW_BANNER_KEY, JSON.stringify(show), {
            path: '/',
            sameSite: 'Lax',
        });
    };

    const handleClose = () => {
        setIsShow(false);
        saveBannerCookieState(false);
    };

    useEffect(() => {
        let isBrowserNeedBanner;
        if (isShowInYandexOrAtom) {
            isBrowserNeedBanner = true;
        } else {
            isBrowserNeedBanner = !isYandexOrAtomBrowser();
        }
        const isUserNeedBanner = checkIfUserNeedBanner();
        setIsShow(isBrowserNeedBanner && isUserNeedBanner);
    }, [isShowInYandexOrAtom]);

    return (isDisplayBar
        && <div className={styles.NotificationBar} data-is-show={isShow} style={{ backgroundColor }}>
            {icon ? <img
                className={styles.NotificationIcon}
                alt="Информация"
                src={transformLink(icon)}
                loading="lazy"
            /> : <div className={styles.EmptyIcon}/>}
            <div
                className={styles.NotificationText}
                dangerouslySetInnerHTML={{ __html: htmlText }}
            />
            {isClosable ? <button
                className={styles.CloseButton}
                onClick={handleClose}
                aria-label="Закрыть уведомление"
            >
                <img
                    src={closeIcon}
                    alt="Закрыть"
                    loading="lazy"
                />
            </button> : <div className={styles.EmptyIcon}/>}
        </div>
    );
};

export default NotificationBar;
